import { route } from 'mithril'
import BaseClass from '../../application/BaseClass'
import slideshowVm from '../vms/slideshowVm'
import SlideshowView from '../views/SlideshowView'
import { make as makeComponent } from '../../utils/component'

class SlideshowController extends BaseClass {
  constructor(options = {}) {
    super(options)
    this.vm = slideshowVm
    this.vm.startSlideChange({
      slideId: this.vm.getCurrentSlideIndex(route.param('slideId')),
    })
  }
}

export default makeComponent(SlideshowController, SlideshowView).call()



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/components/slideshowComponent.js